import {
  LongOrderPreparedPayloadRow,
  OrderPreparedPayloadRow,
} from "./orderTypes";

async function sha256Hex(input: string): Promise<string> {
  const buffer = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(input),
  );
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

const isLongOrderRow = (
  row: OrderPreparedPayloadRow | LongOrderPreparedPayloadRow,
): row is LongOrderPreparedPayloadRow => "startDate" in row;

const extractRowHashData = (
  row: OrderPreparedPayloadRow | LongOrderPreparedPayloadRow,
) => {
  if (isLongOrderRow(row)) {
    return {
      workLocationId: row.workLocationId,
      workTitleId: row.workTitleId,
      startDate: row.startDate,
      endDate: row.endDate,
      requiredTalentAmount: row.requiredTalentAmount,
      tesId: row.tesId,
      costCenterIds: [...row.customerCostCenterIds].sort(),
    };
  }
  return {
    workLocationId: row.workLocationId,
    workTitleId: row.workTitleId,
    startDate: row.time.start ?? row.time.startRange?.start,
    endDate: row.time.end,
    requiredTalentAmount: undefined,
    tesId: row.tesId,
    costCenterIds: [row.customerCostCenterId].sort(),
  };
};

export const generateOrderIdempotencyKey = async (
  rows: (OrderPreparedPayloadRow | LongOrderPreparedPayloadRow)[],
): Promise<string> => {
  const keyData = rows
    .map(extractRowHashData)
    .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
  return sha256Hex(JSON.stringify(keyData));
};
